<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="d-flex flex-row justify-content-start align-items-center">
  <div class="sp-icon">
    <!--
    <img height="35" src="assets/img/SP_Icon_Cartographer.png" alt="Definitions">
    -->
  </div>
  <mat-form-field style="width: 320px">
    <mat-icon matPrefix svgIcon="ic_magnify_search"></mat-icon>
    <input
      matInput
      [(ngModel)]="filterString"
      (keyup)="applyFilter($event.target.value)"
      placeholder="Search"
      />
    @if (filterString != '') {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-paginator
    #paginator
    [length]="totalRows$ | async"
    [pageIndex]="0"
    [pageSize]="20"
    [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]"
  ></mat-paginator>
  <div class="spacer"></div>
  <div class="button-end list-actions">
    <ng-container *ngTemplateOutlet="tableActionTemplate"></ng-container>
  </div>
  <div class="spacer"></div>
</div>

@if (loading) {
  <mat-card
    appearance="outlined"
    style="display: flex; justify-content: center; align-items: center"
    >
    <mat-progress-spinner color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </mat-card>
}

<mat-accordion [class.d-none]="loading" displayMode="flat" multi class="mat-mdc-table">
  <section matSort class="mat-elevation-z2 mat-mdc-header-row">
    @for (label of displayedColumns; track label; let idx = $index) {
      <div class="mat-mdc-header-cell" [mat-sort-header]="label">{{ label }}</div>
    }
  </section>
  @for (item of displayedRows$ | async; track trackByFn.bind(this)($index, item)) {
    <mat-expansion-panel
      [expanded]="isExpanded(item)"
      (afterExpand)="afterExpand($event, item)"
      (afterCollapse)="afterCollapse($event, item)"
      >
      <mat-expansion-panel-header
        class="mat-mdc-row"
        [ngClass]="!getRowStyle ? '' : getRowStyle(item)"
        >
        @for (key of displayedColumns; track key; let idx = $index) {
          @switch (idx) {
            <!-- first cell -->
            @case (0) {
              <span class="mat-mdc-cell">
                {{ item[key] }}
              </span>
            }
            <!-- Regular Cell -->
            @default {
              <span class="mat-mdc-cell">
                {{ item[key] }}
              </span>
            }
            <!-- Actions Cell -->
            @case (displayedColumns.length - 1) {
              <span class="mat-mdc-cell">
                <ng-container
              *ngTemplateOutlet="
                tableActionItemTemplate;
                context: { $implicit: item }
              "
                ></ng-container>
              </span>
            }
          }
        }
      </mat-expansion-panel-header>
      <ng-container
        *ngTemplateOutlet="tableItemContent; context: { $implicit: item }"
        >
      </ng-container>
    </mat-expansion-panel>
  }
</mat-accordion>
